<template>
    <div>
      <object 
        :data="Constants.ServerUrl + '/service/devize/fisa_pdf/' + IdDeviz + '/0'" 
        type="application/pdf" 
        width="100%" 
        :height="parentHeight">
      </object>
      <img 
        v-if="SemnaturaConsimtamant" 
        :src="SemnaturaConsimtamant" 
        alt="Semnătură" 
        style="max-width: 300px; margin-top: 20px;" />
    </div>
  </template>
 
<script>
import settings from "@/backend/LocalSettings"
import BasePage from '@/pages/Admin/BasePage' 
import Constants from '@/backend/Constants'
export default {
    name: "deviz_consimtamant_pdf",
    extends: BasePage,

    data(){
        return {
            Constants: Constants,
            IdDeviz: this.$route.params.IdDeviz,
            parentHeight: 1000,    
            SemnaturaConsimtamant: null,    
        }
    },
    methods: {

    },
    async mounted() {
        try {
            const  response = await this.$http.post('login/check_php_login', {token: settings.get_token} );
            if(response) {
                if(response.body.token_activ == 0){
                    this.$router.push("/");
                }else{
                    const response_semnatura = await this.$http.post("service/devize/get_semnatura_consimtamant", {IdDeviz: this.IdDeviz});
                    if(response_semnatura.body.message){
                        this.$message({type: 'error', message: response_semnatura.body.message, duration: 10000});
                        this.SemnaturaConsimtamant = response_semnatura.body.SemnaturaConsimtamant;
                    }
                }
            } else {
                this.$router.push("/");
            }
        } catch (error) {
            this.$router.push("/");
            this.$message({type: 'error', message: 'A intervenit o eroare in printarea consimtamantului!'});
            console.error(error);
        }
        
    }
}
</script>

